module.exports = __webpack_public_path__ + "img/ME.3d6cc231.png";